<template>
  <success title="已发起询价" :btn-list="btnData" :show-middle-close-btn="true">
    <p class="result_tips">询价{{inquiryTime[this.dataObj.period_type]}}，将在{{this.dataObj.finished_at}}结束询价</p>
  </success>
</template>
<script>

import Success from '../components/Success'
export default {
  components: {
    Success
  },
  data() {
    return {
      dataObj: {
        period_type: 0, // # 成功创建的询价的id
        finished_at: ''
      },
      inquiryTime: ['未知', '15分钟', '30分钟', '45分钟', '60分钟', '2小时', '4小时', '12小时'],
      btnData: []
    }
  },
  created() {
    this.dataObj = this.$route.query
    this.initBtn()
  },
  mounted() {
    const wrapperDom = document.getElementsByClassName('children-wrapper')[0]
    if (!wrapperDom) return
    wrapperDom.style.minHeight = '0'
    wrapperDom.style.height = '100%'
  },
  beforeDestroy() {
    const wrapperDom = document.getElementsByClassName('children-wrapper')[0]
    if (!wrapperDom) return
    wrapperDom.style.minHeight = '100%'
  },
  methods: {
    async initBtn() {
      let id = this.$route.params.id
      let source = this.$route.params.source
      const auth = await this.$store.state.promiseAuth
      const hasAuth = (auth.authList.includes('used_car_ticket.enquiry.view') && source === 'inquiry') ||
                      (auth.authList.includes('used_car_car.enquiry.view') && source === 'auction')
      if (!hasAuth) return
      this.btnData.push({
        link: `/inquiry/inquiryInfo/${id}/${source}?need_btn=0`,
        name: '查看询价信息'
      })
    }
  }
}
</script>
<style lang="less">
@import "../../stylesheets/modules/components/success.less";
</style>
